export default "__VITE_ASSET__83p8Kp6I__"